import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';


const ShopifyActionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/shopify/shopify-actions" */
    'routes/Sources/Shopify/ShopifyActionsRoute'
  )
));

const ShopifySettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/shopify/shopify-settings" */
    'routes/Sources/Shopify/ShopifySettingsRoute'
  )
));

const EditShopifySettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/shopify/edit-shopify-settings" */
    'routes/Sources/Shopify/EditShopifySettingsRoute'
  )
));

const BigCommerceActionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/bigcommerce/bigcommerce-actions" */
    'routes/Sources/BigCommerce/BigCommerceActionsRoute'
  )
));

const BigCommerceSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/bigcommerce/bigcommerce-settings" */
    'routes/Sources/BigCommerce/BigCommerceSettingsRoute'
  )
));

const EditBigCommerceSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/bigcommerce/edit-bigcommerce-settings" */
    'routes/Sources/BigCommerce/EditBigCommerceSettingsRoute'
  )
));

const EasyStoreActionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/easystore/easystore-actions" */
    'routes/Sources/EasyStore/EasyStoreActionsRoute'
  )
));

const EasyStoreSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/easystore/easystore-settings" */
    'routes/Sources/EasyStore/EasyStoreSettingsRoute'
  )
));

const EditEasyStoreSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/easystore/edit-easystore-settings" */
    'routes/Sources/EasyStore/EditEasyStoreSettingsRoute'
  )
));


const ShoplineActionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/shopline/shopline-actions" */
    'routes/Sources/Shopline/ShoplineActionsRoute'
  )
));

const ShoplineSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/shopline/shopline-settings" */
    'routes/Sources/Shopline/ShoplineSettingsRoute'
  )
));

const EditShoplineSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/shopline/edit-shopline-settings" */
    'routes/Sources/Shopline/EditShoplineSettingsRoute'
  )
));

const WixActionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/wix/wix-actions" */
    'routes/Sources/Wix/WixActionsRoute'
  )
));

const WixSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/wix/wix-settings" */
    'routes/Sources/Wix/WixSettingsRoute'
  )
));

const EditWixSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/sources/wix/edit-wix-settings" */
    'routes/Sources/Wix/EditWixSettingsRoute'
  )
));



const getSourcesRoutes = () => {
  return [

    {path: paths.getPathShopifyActions(), component: ShopifyActionsRoute},
    {path: paths.getPathShopifySettings(), component: ShopifySettingsRoute},
    {path: paths.getPathEditShopifySettings(), component: EditShopifySettingsRoute},

    {path: paths.getPathBigCommerceActions(), component: BigCommerceActionsRoute},
    {path: paths.getPathBigCommerceSettings(), component: BigCommerceSettingsRoute},
    {path: paths.getPathEditBigCommerceSettings(), component: EditBigCommerceSettingsRoute},

    {path: paths.getPathEasyStoreActions(), component: EasyStoreActionsRoute},
    {path: paths.getPathEasyStoreSettings(), component: EasyStoreSettingsRoute},
    {path: paths.getPathEditEasyStoreSettings(), component: EditEasyStoreSettingsRoute},

    {path: paths.getPathShoplineActions(), component: ShoplineActionsRoute},
    {path: paths.getPathShoplineSettings(), component: ShoplineSettingsRoute},
    {path: paths.getPathEditShoplineSettings(), component: EditShoplineSettingsRoute},

    {path: paths.getPathWixActions(), component: WixActionsRoute},
    {path: paths.getPathWixSettings(), component: WixSettingsRoute},
    {path: paths.getPathEditWixSettings(), component: EditWixSettingsRoute},
  ]
}


export { getSourcesRoutes };
